// removed by extract-text-webpack-plugin
module.exports = {"discount":"_2BbbAOvyAB-xIbHOH_MlZP c-slate fontSize-s fontWeight-3 fontWeight-4 lineHeight-s","originalPrice":"_gTd3H1j4j8R8k1GO1UN1 c-silver fontWeight-4 opacity-60 textDecoration-lineThrough","perYear":"_1l-P15uuIZLNf7fG7nkGEz fontWeight-3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Pricing/DiscountPrice/DiscountPrice.css
// module id = 765
// module chunks = 18116671869107 156544657062075